import { IAuthentication } from "interfaces/IAuthentication"
import { ILogin } from "interfaces/ILogin"

import { api as apiService, ApiService } from "./api"

class AuthenticationService {
  constructor(private readonly api: ApiService) {}

  public postLogin = async (login: ILogin): Promise<IAuthentication> => {
    return await this.api.post(authUrl + "/v2/token", login)
  }

  public getUserInfo = async () => {
    return await this.api.get(process.env.REACT_APP_TORANJA_API + "/me/")
  }
}
const authUrl = process.env.REACT_APP_AUTH_API
export const authenticationService = new AuthenticationService(apiService)
